<template>
  <div class="c-create-role">
    <div class="form-container">
      <n-loader :loading="$var('load')" />
      <div class="title">Добавление новой роли</div>
      <div class="input-place">
        <div class="text">Название роли:</div>
        <div class="input">
          <n-input v-bind="$form.input('description')" placeholder="Напишите название роли" />
        </div>
      </div>
      <div class="input-place">
        <div class="text">Выдать роль: </div>
        <div class="radios">
          <c-checkbox
            title="Филиалу"
            :checked="modelType === 'branch'"
            @change="(val) => {modelType = val ? 'branch' : ''}"
          />
          <c-checkbox
            title="Отделу"
            :checked="modelType === 'department'"
            @change="(val) => {modelType = val ? 'department' : ''}"
          />
          <c-checkbox
            title="Точке контроля"
            :checked="modelType === 'locationPoint'"
            @change="(val) => {modelType = val ? 'locationPoint' : ''}"
          />
          <c-checkbox
            title="Должности"
            :checked="modelType === 'position'"
            @change="(val) => {modelType = val ? 'position' : ''}"
          />
        </div>
      </div>
      <div class="permits-wrap">
        <div v-for="(item, index) in list" :key="index" class="permits-row">
          <div class="header" :class="{'active': activeTab === index}">
            <div class="left" :class="{'active': isMainActive(index)}" @click="selectMain(index)">
              <div class="title">{{ headers[index] }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="list[activeTab]" class="permissions">
        <div
          v-for="permit in list[activeTab]"
          :key="permit?.id"
          class="item"
        >
          <c-checkbox
            :title="permit?.description"
            :checked="isChildActive(activeTab, permit?.name)"
            @change="selectChild(activeTab, permit)" />
        </div>
      </div>

      <div class="buttons">
        <n-button @click="create">Добавить</n-button>
      </div>
    </div>
  </div>
</template>
<script>

import CCheckbox from '../c-checkbox/Index.vue'

export default {
  name: 'CCreateRole',
  components: { CCheckbox, },
  data() {
    return {
      list: {},
      selected: {},
      headers: {
        users: 'Пользователи',
        branches: 'Филиалы',
        visits: 'Посещения',
        departments: 'Отделы',
        positions: 'Должности',
        scheduleTemplates: 'Расписания',
        organizations: 'Организации',
        roles: 'Роли и доступы',
        companies: 'Компания',
        salaries: 'Финансы',
        requests: 'Запросы',
        requestsTemplate: 'Шаблоны запросов',
        settingsTemplates: 'Шаблоны настроек',
      },
      modelType: '',
      open: '',
      activeTab: 'users',
    }
  },
  created() {
    this.loadList()
    this.$form.init({
      description: '',
    })
    this.$form.rules({
      description: [ 'required', ],
    })
  },
  methods: {
    isMainActive(name) {
      return !!this.selected?.[name]
    },
    isChildActive(name, childName) {
      let is = false

      if (this.selected?.[name]) {
        $n.each(this.selected?.[name], (e) => {
          if (e.name === childName) {
            is = true
          }
        })
      }

      return is
    },
    pluckIds() {
      const ids = []
      $n.each(this.selected, (e) => {
        $n.each(e, (p) => {
          ids.push(p?.id)
        })
      })

      return ids
    },
    selectChild(name, child) {
      if (this.selected?.[name]) {
        let isExist = false

        $n.each(this.selected?.[name], (e) => {
          if (e.name === child.name) {
            isExist = true
          }
        })

        if (isExist) {
          let v = {}
          $n.each(this.selected?.[name], (e) => {
            if (e.name !== child.name) {
              v = {
                ...v,
                [e.name]: e,
              }
            }
          })
          this.selected = {
            ...this.selected,
            [name]: v,
          }
        } else {
          this.selected = {
            ...this.selected,
            [name]: {
              ...this.selected[name],
              [child.name]: child,
            },
          }
        }
      } else {
        this.selected = {
          ...this.selected,
          [name]: { [child.name]: child, },
        }
      }
    },
    selectMain(name) {
      this.activeTab = name
    },
    loadList() {
      this.$var('load', true)
      $api.accesses.getPermits().all().then((response) => {
        this.list = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    create() {
      if (this.$form.check()) {
        const data = {
          description: this.$form.get('description'),
          permitsIds: this.pluckIds(),
        }
        if (this.modelType.length > 0 ) {
          data.modelType = this.modelType
        }
        this.$var('load', true)
        $api.accesses.createRole(data).then(() => {
          this.$emit('created')
          this.selected = {}
          this.$form.reset()
          this.$emit('update:show', false)
        }).finally(() => {
          this.$var('load', false)
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-create-role {
  margin-top: 20px;

  ::v-deep {
    .custom-checkbox {
      padding: 12px 0 10px 2px !important;
      border-bottom: 1px solid #fff;

      .title {
        margin-left: 12px;
        font-size: 16px;
      }
    }
  }

  .buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    ::v-deep {
      .gray {
        background-color: #E9E9E9;
        border-color: #E9E9E9;
        color: #000000;
      }
    }
  }

  .switcher {
    flex-shrink: 0;
    width: 60px;
    height: 30px;
    background-color: #E9E9E9;
    border-radius: 15px;
    position: relative;
    cursor: pointer;
    transition: background-color 0.3s ease;
    border: 1px solid #E9E9E9;

    &:before {
      content: '';
      display: block;
      width: 28px;
      height: 28px;
      background-color: #fff;
      border-radius: 50%;
      position: absolute;
      top: 0;
      left: 0;
      transition: transform 0.3s ease;
    }

    &.active {
      background-color: var(--primary);
    }

    &.active::before {
      transform: translateX(30px);
    }
  }


  .input-place {
    display: flex;
    margin-top: 15px;
    flex-direction: column;


    .radios {
      display: flex;
      align-items: center;
      :deep() {
        .custom-checkbox {
          margin-right: 15px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .text {
      margin-right: 15px;
      margin-bottom: 10px;
    }

    .input {
      flex: 2;
    }
  }

  .buttons {
    display: flex;
    justify-content: flex-end;
  }

  ::v-deep {
    .n-button {
      margin-top: 20px;
      min-width: 200px;
      height: 48px;
      color: #FFFFFF;
      border: 3px solid var(--primary);
      border-radius: 12px;
      background-color: var(--primary);
    }
  }


  .permits-wrap {
    overflow: auto;
    display: flex;
    padding-bottom: 5px;
    .permits-row {
      flex-shrink: 0;
      margin-top: 15px;
      display: flex;
      .header {
        display: flex;
        align-items: center;
        padding: 10px 5px;
        margin-right: 20px;
        justify-content: space-between;

        &.active {
          border-bottom: 2px solid #2A2766;
          font-weight: bold;
          color: #2A2766;
        }

        .left {
          display: flex;
          align-items: center;

          .title {
            font-size: 16px;

          }
        }

        .right {
          cursor: pointer;
          font-size: 23px;
          transition: 500ms;

          &.active {
            transform: rotate(180deg);
          }
        }
      }

      .drop-list {
        transition: 500ms;

        &.active {
          border-bottom: 1px solid #E9E9E9;
        }

        .switcher {
          width: 40px;
          height: 20px;

          &:before {
            width: 18px;
            height: 18px;
          }

          &.active::before {
            transform: translateX(20px);
          }
        }

        .item {
          margin-right: 15px;
          padding: 10px;
          display: flex;
          align-items: center;

          .title {
            margin-right: 10px;
            font-size: 12px;
          }
        }
      }
    }

    //.permissions {
    //  flex: 2;
    //  background-color: #fff;
    //  border-radius: 12px;
    //  padding: 20px;
    //  margin-top: 20px;
    //
    //  .item {
    //    display: flex;
    //    align-items: center;
    //    margin-bottom: 12px;
    //
    //
    //
    //    .title {
    //      font-size: 14px;
    //      margin-right: 10px;
    //    }
    //
    //    .switcher {
    //      width: 40px;
    //      height: 20px;
    //      background-color: #E9E9E9;
    //      border-radius: 15px;
    //      position: relative;
    //      cursor: pointer;
    //      border: 1px solid #E9E9E9;
    //      transition: 0.3s;
    //
    //      &:before {
    //        content: '';
    //        position: absolute;
    //        width: 18px;
    //        height: 18px;
    //        background-color: #fff;
    //        border-radius: 50%;
    //        top: 1px;
    //        left: 1px;
    //        transition: 0.3s;
    //      }
    //
    //      &.active {
    //        background-color: var(--primary);
    //
    //        &:before {
    //          transform: translateX(20px);
    //        }
    //      }
    //    }
    //  }
    //}
  }

  .permissions {
    margin-top: 20px;
  }


  .form-container {
    background-color: #F1F4FC;
    border-radius: 12px;
    padding: 24px;
    .title {
      text-align: center;
      font-size: 18px;
    }
  }

  .radio {
    cursor: pointer;
    display: flex;
    align-items: center;
    .title {
      font-size: 16px;
      margin-right: 15px;
    }
    .circle {
      background-color: #E9E9E9;
      border-radius: 50%;
      width: 18px;
      height: 18px;
      transition: 0.3s;
      &.active {
        background-color: var(--primary);
      }
    }
  }
}
</style>
